/**
 * Single source of truth for the hospital name shown on printed patient documents
 * (prescriptions, medication reports, etc). Previously PrintableMedications.tsx and
 * PrintablePrescription.tsx each read process.env.REACT_APP_HOSPITAL_NAME with their own
 * different, client-specific hard-coded default ('SIG' vs 'SIH') — so an unconfigured
 * deployment would silently print another client's name. Falls back to an empty string,
 * never a specific client's name.
 */
export const getHospitalName = (): string => process.env.REACT_APP_HOSPITAL_NAME || ''
